import { useEffect } from 'react';

/**
 * Used when you want the user to confirm navigating away from the page based on a condition
 * @param message The confirmation message to show
 * @param condition If true, navigation will be blocked with the confirmation dialog
 */
export function useConfirmNavigation(message: string, condition: boolean) {
  // Block browser refresh/close/tab close
  useEffect(() => {
    if (!condition) return;
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [condition, message]);

  // Intercept browser back button navigation
  useEffect(() => {
    if (!condition) return;
    // Push a state to the history stack to allow intercepting the back action
    window.history.pushState({}, '', window.location.href);

    const handlePopState = (_: PopStateEvent) => {
      const confirmLeave = window.confirm(message);
      if (confirmLeave) {
        window.history.go(-1);
      } else {
        window.history.pushState({}, '', window.location.href);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [condition, message]);
}
